import { EditEvent } from '@features/calendar/components/EditEvent'
import { Card } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/calendar/events_/$eventId/edit')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Edit',
        }
    }
})

function RouteComponent() {

    const eventId = Route.useParams().eventId

    return (
        <Card withBorder radius="md" p={'xs'} className="h-full min-h-0 overflow-hidden">
            <EditEvent eventId={Number(eventId)} />
        </Card>
    )
}
